<template>
    <div
        :id="`theme-block-${index + 1}`"
        v-observe-visibility="{callback: themeVisibilityChanged,
                               throttle: 50}"
        class="theme-block"
    >
        <theme-divider :id="`theme-divider-${index + 1}`">
            <template #label>
                {{ index + 1 }}. {{ theme.title }}
            </template>
        </theme-divider>
        <h1 class="title">
            {{ theme.title }}
        </h1>
        <h3 v-if="theme.subheading" class="subheading">
            {{ theme.subheading }}
        </h3>
        <div class="body" :style="themeFontStyles">
            <p v-html="theme.body" />
        </div>
    </div>
</template>

<script>
export default {
    name: "Theme",
    components: {
        themeDivider: () => import(/* webpackChunkName: "theme-divider"*/ "./theme-divider")
    },
    props: {
        theme: {
            type: Object,
            default() {
                return {}
            }
        },
        index: {
            type: [String, Number],
            default: 1
        },
        themeFontStyles: {
            type: Object,
            required: true
        }
    },
    methods: {
        themeVisibilityChanged(isVisible = false) {
            this.themeIsVisible = isVisible;
            if (isVisible) {
                this.$store.dispatch("NonfictionReader/setSelectedReaderTheme", this.index);
            }
        }
    }
}
</script>

<style lang="scss">
    .theme-block {
        .title {
            color: white;
            font-size: 32px;
            font-weight: 500;
            line-height: 43px;
        }

        .author {
            color: $medium-gray;
            font-size: 26px;
            font-weight: 600;
            line-height: 36px;
            margin-bottom: 40px;
        }

        .body {
            * {
                color: white !important;
                font-size: inherit !important;
                line-height: inherit !important;
                margin-bottom: 0;
                background-color: transparent !important;
            }

            ul, ol {
                li:not(:last-child) {
                    margin-bottom: 30px;
                }
            }
        }
    }
</style>
